import { CurrentEnvironment } from './services/ServiceConstants';

export type LogMessage = {
  message: string;
};
export function DebugLogger(prefix: String = ''): (_: LogMessage) => void {
  return function ({ message }) {
    if (CurrentEnvironment !== 'localDev') {
      return;
    }

    console.log(prefix, message);
  };
}
